import { useTheme } from "@emotion/react";
import React, { useState, useEffect, useRef } from "react";
import { AngleDown } from "./ui-icons";

const CcTextAccordion = ({ text, isOpen }) => {
  const [fullTextVisible, setFullTextVisible] = useState(isOpen);
  const theme = useTheme();
  const accordionRef = useRef(null);

  const baseHeight = 23;

  const accordionWrapperStyle = {
    borderBottom: `1px solid ${theme.colors.gray}`,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    paddingBottom: theme.f_sizes.base,
  };

  const accordionParagraphStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: 4,
    marginBottom: 0,
  };

  const accordionStyle = {
    maxWidth: "calc(100% - 30px)",
    height: baseHeight,
    minHeight: baseHeight,
    overflow: "hidden",
    "&.is-open p": {
      textOverflow: "initial",
      whiteSpace: "normal",
      wordBreak: "break-word",
    },
  };

  const toggleBtnStyle = (active) => ({
    backgroundColor: "transparent",
    border: 0,
    color: active ? theme.colors.primary : theme.colors.black,
    cursor: "pointer",
    display: "block",
    flexShrink: 0,
    marginLeft: "auto",
    padding: 0,
    transition: "all .2s ease-in-out",
    transform: active ? "scaleY(-1)" : "unset",
    "svg": {
      height: baseHeight,
      width: "auto",
    },
  });

  const marginOffset = 6;

  useEffect(() => {
    if (!isOpen) return;
    const element = accordionRef.current;
    element.classList.add("is-open");
    const openHeight = element.querySelector("p").getBoundingClientRect().height + marginOffset;
    element.setAttribute("style", `height: ${openHeight}px`);
  }, [isOpen, text]);

  const animateStep = (count, step) => {
    const element = accordionRef.current;
    const currentHeight = element.getBoundingClientRect().height;
    element.setAttribute("style", `height: ${currentHeight + step}px`);
    if (count >= 0) window.requestAnimationFrame(() => animateStep(count -1, step));
  };

  const animateHeight = () => {
    const element = accordionRef.current;
    let wasOpen = true;
    if (!element.classList.contains("is-open")) {
      element.classList.add("is-open");
      wasOpen = false;
    }
    const openHeight = element.querySelector("p").getBoundingClientRect().height + marginOffset;
    const timer = 200;
    const steps = Math.floor(timer / 16.7) + 2;
    const animatedHeight = parseInt(`${wasOpen ? "-" : ""}${openHeight - baseHeight}`, 10);
    const stepHeight = Math.floor(animatedHeight / steps);

    window.requestAnimationFrame(() => animateStep(steps, stepHeight));
    if (element.classList.contains("is-open") && wasOpen) element.classList.remove("is-open");
  };

  return(
    <div css={accordionWrapperStyle}>
      <div css={accordionStyle} ref={accordionRef}>
        <p
          css={accordionParagraphStyle}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
      <button
        type="button"
        onClick={() => {
          setFullTextVisible((prevState) => !prevState);
          animateHeight()
        }}
        css={toggleBtnStyle(fullTextVisible)}
      >
        <AngleDown />
      </button>
    </div>
  );
};

export default CcTextAccordion;
